module.exports = __webpack_public_path__ + "img/island.bffb8a6.svg";